export default "__VITE_ASSET__CYf0KHqV__"